module.exports = __webpack_public_path__ + "img/Ideas.a58a4198.jpg";